import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Radio,
  FormControlLabel,
  Grid,
  Typography,
  Avatar,
  Button,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Badge,
  Chip,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import dayjs from "dayjs";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import { FaList } from "react-icons/fa";

import classes from "./myteam.module.css";
import {
  locationStatusFilter,
  locationTimeFilter,
} from "../../../utilities/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  saveLocationStatusFilter,
  saveLocationTimeFilter,
} from "../../../Redux/actions/location-action";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { TEAM_MEMBER_DETAILS } from "../../../api-calls/api-urls";
import {
  stringAvatar,
  generateColor,
  getChipColor,
  findOnline,
  checkOnline,
} from "../../../utilities/commonFunctions";
import moment from "moment";
import MyTableBody from "../../../components/LocationListView";
import { useNavigate } from "react-router-dom";
import { TeamMemberData } from "../../../Redux/actions/team-actions";
import { getLanguagedataFunction } from "../../../utilities/language";
import {
  ArrowDownIcon,
  DatePickerCalendarIcon,
  FilterIcon,
  SortIcons,
} from "../../../components/Icons";

const TeamMemberLocations = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [date, setDate] = React.useState(null);
  const [anchorEl, setAnchorEl] = useState(null); // State to anchor the menu
  const [anchorEl1, setAnchorEl1] = useState(null);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [selectedDate, setSelectedDate] = useState();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const open = Boolean(anchorEl);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const open1 = Boolean(anchorEl1); // State to anchor the menu
  const [selectedValues, setSelectedValues] = useState(locationStatusFilter); // State to store selected values
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [isOnline, setIsOnline] = useState(false);
  const [selectedValues1, setSelectedValues1] = useState("newest_to_oldest");
  const [activeButton, setActiveButton] = useState("grid");
  const { locationFilteredStatus, locationFilterTime } = useSelector(
    (state) => state.location
  );
  const { teamMemberData } = useSelector((state) => state.teams);
  const ln = useSelector((state) => state.allUsers.language_json);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once on mount (getLanguagedataFunction is idempotent)

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  const getTeamMemberData = async (userEntry) => {
    const path = window.location.pathname.split("/");
    if (fromDate !== undefined && toDate !== undefined) {
      const { data } = await authApi.post(
        `${TEAM_MEMBER_DETAILS}/${path[path?.length - 1]}?start_date=${moment(
          fromDate
        ).format("YYYY-MM-DD")}&end_date=${moment(toDate).format(
          "YYYY-MM-DD"
        )}&view_all=${true}`,
        userEntry,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      dispatch(TeamMemberData(data));

      getStatus(data.phone);
    } else {
      const { data } = await authApi.post(
        `${TEAM_MEMBER_DETAILS}/${path[path?.length - 1]}?&view_all=${true}`,
        userEntry,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      dispatch(TeamMemberData(data));
      getStatus(data.phone);
    }
  };

  const getStatus = async (phone) => {
    const isOnline = await findOnline(phone);
    setIsOnline(isOnline);
  };

  useEffect(() => {
    const filterArray = {
      status: locationFilteredStatus,
      sortby: locationFilterTime,
    };
    getTeamMemberData(filterArray);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!teamMemberData, locationFilteredStatus, locationFilterTime]);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const location_datas = {
    total: 20,
    completed: 10,
    rejected: 7,
    pending: 3,
  };

  useEffect(() => {
    if (fromDate !== undefined && toDate !== undefined) {
      setSelectedDate(
        `${moment(fromDate).format("DD-MM-YYYY")} to ${moment(toDate).format(
          "DD-MM-YYYY"
        )}`
      );
    }
    getTeamMemberData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, toDate]);

  const handleMenuclick = (event, name) => {
    name(event.currentTarget);
  };
  const clickClearAll = (name, value) => {
    if (value === "array") {
      name([]);
    } else {
      name();
    }
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setAnchorEl1(null);
  };

  const handleCardClick = (e, item) => {
    const name = item.Location.slug.toLowerCase();
    navigate(`/location/${name}`);
    e.preventDefault();
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  const handleClick = (event, name) => {
    if (name === "ref1") {
      setAnchorEl(event.currentTarget);
    } else {
      setAnchorEl1(event.currentTarget);
    }
  };

  const handleStatusCheckbox = (value) => {
    const isSelected = selectedValues.includes(value);

    if (value === "all") {
      if (isSelected) {
        // Unselect all checkboxes
        setSelectedValues([]);
        dispatch(saveLocationStatusFilter([]));
      } else {
        // Select all checkboxes
        setSelectedValues([...locationStatusFilter]);
        dispatch(saveLocationStatusFilter([...locationStatusFilter]));
      }
    } else {
      // Toggle the selection of individual checkboxes
      let newSelectedValues = [];

      if (isSelected) {
        newSelectedValues = selectedValues.filter((v) => v !== value);
      } else {
        newSelectedValues = [...selectedValues, value];
      }
      setSelectedValues(newSelectedValues);

      const areAllSelected = locationStatusFilter
        .filter((item) => item !== "all")
        .every((item) => newSelectedValues.includes(item));

      // Check the "All" checkbox if all others are selected
      if (areAllSelected) {
        setSelectedValues((prevSelected) => [...prevSelected, "all"]);
        dispatch(saveLocationStatusFilter([...newSelectedValues, "all"]));
      } else {
        // Uncheck the "All" checkbox if any other checkbox is unselected
        setSelectedValues((prevSelected) =>
          prevSelected.filter((item) => item !== "all")
        );
        dispatch(
          saveLocationStatusFilter(
            newSelectedValues.filter((item) => item !== "all")
          )
        );
      }
    }
  };
  const handleTimeCheckBox = (value) => {
    setSelectedValues1(value);
    dispatch(saveLocationTimeFilter(value));
  };

  // eslint-disable-next-line unused-imports/no-unused-vars
  const handleEvent = (event, picker) => {
    setFromDate(picker.startDate._d.toISOString());
    setToDate(picker.endDate._d.toISOString());
  };

  return (
    <div>
      {ln ? (
        <div className={classes.TeamMemberLocationPageMaindiv}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={2} sx={{ mb: 3, justifyContent: 'flex-end' }}>
              <Grid item xs={12} sm={6} md={3}>
                <DesktopDatePicker
                  label="Start Date"
                  sx={{ width: '100%' }}
                  value={fromDate ? dayjs(fromDate) : null}
                  onChange={(date) => setFromDate(date?.toISOString())}
                  format="DD-MM-YYYY"
                  slots={{ openPickerIcon: DatePickerCalendarIcon }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <DesktopDatePicker
                  label="End Date"
                  sx={{ width: '100%' }}
                  value={toDate ? dayjs(toDate) : null}
                  onChange={(date) => setToDate(date?.toISOString())}
                  format="DD-MM-YYYY"
                  slots={{ openPickerIcon: DatePickerCalendarIcon }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
          </div>
          {teamMemberData ? (
            <div>
              <Paper className={classes.TeamMemberPiechartBox}>
                <Typography className={classes.teamPageHeading}>
                  {ln.total_locations}
                </Typography>
                <div className={classes.PieChartContainer}>
                  <div style={{ width: "150px", height: "150px" }}>
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 44 44"
                      className={classes.piechartSvg}
                    >
                      <circle
                        cx="50%"
                        cy="50%"
                        fill="transparent"
                        r="15.909091"
                        stroke="#eee"
                        strokeWidth={10}
                      />
                      <circle
                        show-tip="ctDonutTip"
                        className="ct-donut-slice"
                        cx="50%"
                        cy="50%"
                        fill="transparent"
                        r="15.909091"
                        stroke="#1273B8" // Completed color
                        strokeDasharray={`${
                          (teamMemberData.locationDetails.completed /
                            teamMemberData.locationDetails.total) *
                          100
                        } ${
                          (teamMemberData.locationDetails.total -
                            teamMemberData.locationDetails.completed /
                              teamMemberData.locationDetails.total) *
                          100
                        }`}
                        strokeWidth={10}
                        strokeDashoffset={0}
                        slice-title="Completed"
                        percent-value={11}
                        usage={11}
                        total-val={20}
                      >
                        <animate
                          attributeName="stroke-dashoffset"
                          from={100}
                          to={0}
                          dur="0.5s"
                        />
                      </circle>
                      <circle
                        show-tip="ctDonutTip"
                        className="ct-donut-slice"
                        cx="50%"
                        cy="50%"
                        fill="transparent"
                        r="15.909091"
                        stroke="#240051" // Pending color
                        strokeDasharray={`${
                          (teamMemberData.locationDetails.pending /
                            teamMemberData.locationDetails.total) *
                          100
                        } ${
                          (teamMemberData.locationDetails.total -
                            teamMemberData.locationDetails.pending /
                              teamMemberData.locationDetails.total) *
                          100
                        }`}
                        strokeWidth={10}
                        strokeDashoffset={
                          -(
                            teamMemberData.locationDetails.completed /
                            teamMemberData.locationDetails.total
                          ) * 100
                        } // Adjusted to start from the end point of the second slice
                        slice-title="Pending"
                        percent-value={2}
                        usage={2}
                        total-val={20}
                      >
                        <animate
                          attributeName="stroke-dashoffset"
                          from={100}
                          to={-100} // Adjusted to start from the end point of the second slice
                          dur="0.5s"
                        />
                      </circle>
                      <circle
                        show-tip="ctDonutTip"
                        className="ct-donut-slice"
                        cx="50%"
                        cy="50%"
                        fill="transparent"
                        r="15.909091"
                        stroke="#C52A38" // Rejected color
                        strokeDasharray={`${
                          (teamMemberData.locationDetails.rejected /
                            teamMemberData.locationDetails.total) *
                          100
                        } ${
                          (teamMemberData.locationDetails.total -
                            teamMemberData.locationDetails.rejected /
                              teamMemberData.locationDetails.total) *
                          100
                        }`}
                        strokeWidth={10}
                        strokeDashoffset={
                          -(
                            (teamMemberData.locationDetails.completed +
                              teamMemberData.locationDetails.pending) /
                            teamMemberData.locationDetails.total
                          ) * 100
                        } // Adjusted to start from the end point of the second slice
                        slice-title="Rejected"
                        percent-value={7}
                        usage={7}
                        total-val={20}
                      >
                        <animate
                          attributeName="stroke-dashoffset"
                          from={100}
                          to={-100} // Adjusted to start from the end point of the second slice
                          dur="0.5s"
                        />
                      </circle>
                      <circle cx="50%" cy="50%" fill="#FFFFFF" r={16}></circle>

                      <text
                        x="50%"
                        y="52%"
                        className={`ct-donut-center ${classes.svg_TotalNumber}`}
                      >
                        {teamMemberData.locationDetails.total.toLocaleString(
                          "en-US",
                          {
                            minimumIntegerDigits: 2,
                            useGrouping: false,
                          }
                        )}
                      </text>
                      <text
                        x="51%"
                        y="65%"
                        className={`ct-donut-center ${classes.svg_TotalText}`}
                      >
                        Total
                      </text>
                    </svg>
                    <div className="ct-tip" />
                  </div>
                  <div>
                    <div>
                      <Typography style={{ display: "flex" }}>
                        <Avatar
                          sx={{
                            bgcolor: `#1273B8`,
                            width: "13px",
                            height: "13px",
                            marginRight: "5px",
                            marginTop: "5px",
                          }}
                        >
                          {" "}
                        </Avatar>{" "}
                        {ln.reached} :{" "}
                        {teamMemberData.locationDetails.completed}
                      </Typography>
                    </div>
                    <div>
                      <Typography style={{ display: "flex" }}>
                        <Avatar
                          sx={{
                            bgcolor: `#240051`,
                            width: "13px",
                            height: "13px",
                            marginRight: "5px",
                            marginTop: "5px",
                          }}
                        >
                          {" "}
                        </Avatar>{" "}
                        {ln.pending} : {teamMemberData.locationDetails.pending}
                      </Typography>
                    </div>
                    <div>
                      <Typography style={{ display: "flex" }}>
                        <Avatar
                          sx={{
                            bgcolor: `#C52A38`,
                            width: "13px",
                            height: "13px",
                            marginRight: "5px",
                            marginTop: "5px",
                          }}
                        >
                          {" "}
                        </Avatar>{" "}
                        {ln.rejected} :{" "}
                        {teamMemberData.locationDetails.rejected}
                      </Typography>
                    </div>
                  </div>
                </div>
              </Paper>
            </div>
          ) : null}
          <div className={classes.displayFlexContainerSpaceBetween}>
            <div className={classes.displayflexnrmlContainer}>
              <Typography className={classes.teamPageHeading}>
                {ln.locations}
              </Typography>
              <ToggleButtonGroup
                value={activeButton}
                exclusive
                onChange={(_, val) => val && handleButtonClick(val)}
                size="small"
                sx={{
                  ml: 2,
                  "& .MuiToggleButton-root": {
                    color: "#888888 !important",
                    bgcolor: "white",
                    "&:hover": { bgcolor: "#e8f0f8" },
                    "&.Mui-selected": {
                      color: "white !important",
                      bgcolor: "#227dc3",
                      "&:hover": { bgcolor: "#1a6ab0" },
                    },
                  },
                }}
              >
                <ToggleButton value="grid">
                  <BsFillGrid3X3GapFill
                    color={activeButton === "grid" ? "white" : "#888888"}
                  />
                </ToggleButton>
                <ToggleButton value="list">
                  <FaList
                    color={activeButton === "list" ? "white" : "#888888"}
                  />
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
            <div
              style={{ display: "flex", columnGap: 20, alignItems: "center" }}
            >
              <div>
                <Button
                  variant="outlined"
                  className={classes.filterbtns}
                  onClick={(e) => handleMenuclick(e, setAnchorEl)}
                  style={{ background: "white" }}
                >
                  <div>
                    <FilterIcon /> All
                  </div>
                  <div style={{ marginLeft: "5px" }}>
                    <ArrowDownIcon />
                  </div>
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <div className={classes.filterHeading}>
                    <h5>Filter</h5>
                    <span
                      className={classes.claerBtn}
                      onClick={() => clickClearAll(setSelectedValues, "array")}
                    >
                      clear all
                    </span>
                  </div>
                  {locationStatusFilter.map((item, index) => {
                    return (
                      <MenuItem
                        key={index}
                        style={{
                          padding: "6px 16px",
                          textTransform: "capitalize",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={locationFilteredStatus?.includes(item)}
                              onChange={() => handleStatusCheckbox(item)}
                              size="small"
                            />
                          }
                          label={item.replaceAll("_", " ").toLowerCase()}
                        />
                      </MenuItem>
                    );
                  })}
                </Menu>
              </div>
              <div>
                <Button
                  variant="outlined"
                  className={classes.filterbtns}
                  onClick={(e) => handleMenuclick(e, setAnchorEl1)}
                  style={{ background: "white" }}
                >
                  <div>
                    <SortIcons />{" "}
                    {selectedValues1
                      ? selectedValues1?.replaceAll("_", " ")
                      : "Newest to Oldest"}
                  </div>
                  <div>
                    <ArrowDownIcon />
                  </div>
                </Button>
                <Menu
                  anchorEl={anchorEl1}
                  open={Boolean(anchorEl1)}
                  onClose={handleMenuClose}
                >
                  <div className={classes.filterHeading}>
                    <h5>Sort By</h5>
                    <span
                      className={classes.claerBtn}
                      onClick={() =>
                        clickClearAll(setSelectedValues1, "single")
                      }
                    >
                      clear all
                    </span>
                  </div>
                  {locationTimeFilter.map((item, index) => {
                    return (
                      <MenuItem
                        key={index}
                        style={{
                          padding: "6px 16px",
                          textTransform: "capitalize",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Radio
                              checked={selectedValues1 === item}
                              onChange={() => handleTimeCheckBox(item)}
                              size="small"
                            />
                          }
                          label={item.replaceAll("_", " ")}
                        />
                      </MenuItem>
                    );
                  })}
                </Menu>
              </div>
            </div>
          </div>
          {teamMemberData &&
          Array.isArray(teamMemberData.locationDetails.list) ? (
            teamMemberData.locationDetails.list?.length > 0 ? (
              <div>
                {activeButton === "grid" ? (
                  <div className={classes.GridContainer}>
                    {teamMemberData.locationDetails.list.map((item, index) => (
                      <React.Fragment key={index}>
                        <Card
                          key={item.Location._id}
                          className={classes.teamCard}
                          style={{ height: "225px" }}
                          onClick={(e) => handleCardClick(e, item)}
                        >
                          <CardContent
                            sx={{ paddingBottom: "16px !important" }}
                            className={classes.teamCardContent}
                          >
                            <div className={classes.locationGridCardHeader}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  columnGap: "10px",
                                  width: "70%",
                                }}
                              >
                                <Badge
                                  color={
                                    checkOnline(item?.user_id) === "checkin"
                                      ? "success"
                                      : "error"
                                  }
                                  badgeContent=" "
                                  overlap="circular"
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                  }}
                                  variant="dot"
                                >
                                  <Avatar
                                    {...stringAvatar(item.Location.title)}
                                    sx={{
                                      bgcolor: `${generateColor(
                                        item.Location.title
                                      )}`,
                                    }}
                                  />
                                </Badge>
                                <div className={classes.memberCardText}>
                                  <Typography
                                    className={classes.memberCardTextHeading}
                                  >
                                    {item.Location.title}
                                  </Typography>
                                </div>
                              </div>
                              <Chip
                                className={classes.locationStatusChip}
                                label={item.status}
                                size="small"
                                style={getChipColor(item.status)}
                              />
                            </div>
                            <hr className={classes.UnderlineHr} />
                            <div>
                              <div className={classes.memberCardText}>
                                <Typography
                                  className={`${classes.form_lable} ${classes.teamCardTextMain}`}
                                >
                                  {ln.assigned_on}
                                </Typography>
                                <Typography
                                  className={`${classes.memberCardTextHeading}`}
                                >
                                  {moment(item.Location.assigned_on).format(
                                    "DD MMM YYYY, hh:mm A"
                                  )}
                                </Typography>
                              </div>
                            </div>
                            <hr className={classes.UnderlineHr} />
                            <div>
                              {item.status === "completed" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    style={{ width: "45%" }}
                                    className={classes.locationCardButton}
                                  >
                                    {ln.view_route}
                                  </Button>
                                  <Button
                                    variant="contained"
                                    type="submit"
                                    size="small"
                                    style={{ width: "45%" }}
                                    className={classes.locationCardButton}
                                  >
                                    {ln.not_reached}?
                                  </Button>
                                </div>
                              ) : (
                                <div>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    className={classes.locationCardButton}
                                  >
                                    {ln.view_route}
                                  </Button>
                                </div>
                              )}
                            </div>
                          </CardContent>
                        </Card>
                      </React.Fragment>
                    ))}
                  </div>
                ) : (
                  <MyTableBody
                    list={teamMemberData.locationDetails.list}
                    departmentColor={teamMemberData.department?.colour}
                  />
                )}
              </div>
            ) : (
              <Typography variant="h6" className={classes.noLocationsText}>
                No Tasks Found
              </Typography>
            )
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default TeamMemberLocations;
